import { Directive } from '@angular/core';

@Directive()
export abstract class CardContainerBaseComponent {}
